import FileItem from "./File";

const FileList = ({ uploadedFiles, deleteFile, file }) => {
  return (
    <>
      {uploadedFiles.map((doc) => (
        <FileItem doc={doc} deleteFile={deleteFile} />
      ))}
      {file && (
        <FileItem
          doc={{ fileName: file?.name, id: 123, type: "Reference" }}
          deleteFile={deleteFile}
          showProgress
        />
      )}
    </>
  );
};

export default FileList;
